module.exports = __webpack_public_path__ + "img/06.b68ad393.png";